import IBatteryStatus from './IBatteryStatus';

export function getNoBatteryStatus(): IBatteryStatus {
	return {
		percentage: 100,
		chargeType: 'NONE',
		isCharging: true,
		lastChargingTime: new Date(),
		['__emulatedBatteryStatus' as never]: true,
	};
}
